var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "flex gap-2 flex-wrap text-sm font-normal" },
    [
      _vm._l(_vm.filteredChipWithLinkDatas, function (chipWithLinkData, index) {
        return _c("ChipWithLink", {
          key: index,
          attrs: {
            chipClassParent: "customChipWidth",
            variant: chipWithLinkData.variant,
            chipLink: chipWithLinkData.chipLink,
            chipData: chipWithLinkData.chipData,
            avatar: chipWithLinkData.avatar,
            chipText: chipWithLinkData.chipText,
            wrapChip: _vm.wrapChips,
          },
        })
      }),
      _vm.extra > 0
        ? _c(
            "span",
            {
              staticClass: "font-400 py-0.5 px-1.5 rounded-full",
              class: _vm.variantClass,
            },
            [_vm._v("+" + _vm._s(_vm.extra))]
          )
        : _vm._e(),
      !_vm.chipWithLinkDatas.length ? _c("span", [_vm._v("N/A")]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }